// packages/frontend/src/config/endpoints.ts
//
// Single source of truth for backend service base URLs.
// Each value resolves from its VITE_ environment variable, falling back to the
// local dev port. Import these constants instead of re-inlining the
// `import.meta.env.VITE_... || 'http://localhost:...'` fallback in each service.

export const GENAI_BASE_URL: string =
  import.meta.env.VITE_CLOUD_RUN_GENAI_SERVICE_URL || "http://localhost:8080";

export const IMAGE_STORAGE_BASE_URL: string =
  import.meta.env.VITE_CLOUD_RUN_IMAGE_STORAGE_SERVICE_URL ||
  "http://localhost:8081";

export const BACKEND_BASE_URL: string =
  import.meta.env.VITE_BACKEND_API_URL || "http://localhost:3001";

// Firebase Functions emulator base URL. The fallback intentionally omits any
// project id (a stale one used to be hardcoded here); set
// VITE_FIREBASE_FUNCTIONS_URL to the full emulator path
// (http://localhost:5001/<project-id>/us-central1) for local Functions work.
export const FUNCTIONS_BASE_URL: string =
  import.meta.env.VITE_FIREBASE_FUNCTIONS_URL || "http://localhost:5001";

/**
 * In production builds, fail loudly if a required Cloud Run service URL is not
 * configured. Without this, a missing VITE_CLOUD_RUN_* var would silently fall
 * back to localhost in a deployed build. No-op in dev/test.
 */
export function assertEndpointsConfigured(): void {
  if (!import.meta.env.PROD) return;

  const missing: string[] = [];
  if (!import.meta.env.VITE_CLOUD_RUN_GENAI_SERVICE_URL) {
    missing.push("VITE_CLOUD_RUN_GENAI_SERVICE_URL");
  }
  if (!import.meta.env.VITE_CLOUD_RUN_IMAGE_STORAGE_SERVICE_URL) {
    missing.push("VITE_CLOUD_RUN_IMAGE_STORAGE_SERVICE_URL");
  }

  if (missing.length > 0) {
    throw new Error(
      `[endpoints] Missing required environment variables in production build: ${missing.join(", ")}`
    );
  }
}
